import {Box, Button, Stack, Typography} from '@mui/material';
import {ArrowBackIosNew} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import CreateCustomerNew from '../CreateCustomerNew';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

export const CustomerCreatePage = () => {
    const navigate = useNavigate();
    const {t} = useAppTranslation();

    return (
        <Box sx={{width: '100%'}}>
            <Stack spacing={2}>
                <Button variant="outlined" startIcon={<ArrowBackIosNew/>} onClick={() => navigate('..', {relative: 'path'})} sx={{alignSelf: 'flex-start'}}>
                    {t('customers:back_to_customers')}
                </Button>
                <Typography variant="h5">{t('customers:create_customer')}</Typography>
                <CreateCustomerNew handleCreateCustomerDialog={() => navigate('..', {relative: 'path'})}/>
            </Stack>
        </Box>
    );
};
